__webpack_require__.p = "/react-olext.github.io/en/v0.1/examples/basic-app/";